export enum StudentStatus {
    ACTIVE = 'active',
    ACTIVATION_PENDING = 'activation_pending',
    INVITATION_PENDING = 'invitation_pending',
    READY_FOR_EXAM = 'exam_ready',
    PASSED = 'passed',
}
